import { useCallback } from 'react'

import { mixpanel } from '@/mixpanel'
import { navigateToLocation } from '../helpers/navigation'

import type { Location } from '@/modules/shared/types/location.types'

/**
 * Opens the maps app on a location and tracks which route was used. Each screen names its own
 * event; the origin is always the detail, which is the only place that offers the card.
 */
function useNavigateToLocation(eventName: string) {
  return useCallback(
    async (location: Location) => {
      const via = await navigateToLocation(location)
      if (via) {
        mixpanel.track(eventName, { via, origin: 'detail' })
      }
    },
    [eventName],
  )
}

export { useNavigateToLocation }
